import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  defaultTo,
  complement,
  map,
  split,
  flatten,
  unless,
  startsWith,
  concat,
  pipe,
  filter
} from 'ramda'
import withFieldError from 'components/form/with-error'

export const InstagramHashtag = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter hashtag e.g. #hashtag',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

InstagramHashtag.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const InstagramHashtagWithError = withFieldError(InstagramHashtag)

const noValue = either(isNil, isEmpty)

export const validate = cond([[noValue, always('Please enter valid hashtags')]])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty)),
  map(unless(startsWith('#'), concat('#')))
)

const InstagramHashtagField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={InstagramHashtagWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

InstagramHashtagField.propTypes = {
  name: PropTypes.string
}

export default InstagramHashtagField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/instagram/hashtag/index.js